export const APP_NAME = "Ramtek Bazar";

export const COLORS = {
  primary: "bg-blue-600 hover:bg-blue-700",
  danger: "bg-red-600 hover:bg-red-700",
  secondary: "bg-slate-700 hover:bg-slate-600",
  textPrimary:"bg-blue-600 hover:bg-blue-700"
};